<template>
  <div class="page-container">
    <div class="header-body">
      <el-card>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-input
                placeholder="请输入手机号"
                class="input-with-select"
                clearable
                v-model.trim="searchInfo.phone"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchHandle"
                ></el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <div class="search-form">
        <el-form ref="form" :model="searchForm" label-width="80px">
          <el-form-item label="导出范围">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
                v-model="searchForm.startTime"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2" style="text-align: center">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="searchForm.endTime"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <div class="button-box">
              <el-button
                type="success"
                @click="exportExecl"
                v-permission="['company:resource:export']"
                >导出Excel</el-button
              >
              <el-button
                type="warning"
                @click="uploadData.isOpen = !uploadData.isOpen"
                v-permission="['company:resource:import']"
                >导入Excel</el-button
              >
              <el-button type="primary" @click="downloadTemplate"
                >下载模板</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table-body">
      <el-card>
        <el-table :data="resourceList" style="width: 100%" border stripe>
          <el-table-column type="index" label="ID" width="50"></el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="sex" label="性别">
            <template v-slot="scoped">
              <el-tag
                :type="Number(scoped.row.sex) === 1 ? 'warning' : 'danger'"
                v-if="Number(scoped.row.sex) !== 0"
              >
                {{ Number(scoped.row.sex) == 1 ? "男" : "女" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="domicilePlace" label="户籍"> </el-table-column>
          <el-table-column prop="phone" label="手机号码">
            <template v-slot="scoped">
              <span>{{ scoped.row.phone | hidePhone }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="qq" label="QQ"> </el-table-column>
          <el-table-column prop="wxNum" label="微信"></el-table-column>
          <el-table-column prop="department" label="院校"></el-table-column>
          <el-table-column prop="major" label="专业"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scoped">
              <el-button
                type="danger"
                size="small"
                @click="deleteHandle(scoped.row.id)"
                v-permission="['company:resource:delete']"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="pagination-body">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <upload-dialog
      :uploadData="uploadData"
      @closeDialog="closeDialog"
    ></upload-dialog>
  </div>
</template>

<script>
import permission from '@/directive/permission/index.js'
import uploadDialog from './dialog/upload.vue'

import {
  getCompanyResource,
  getInfoByPhone,
  deleteCompanyResouse
} from '@/api/api'
import axios from 'axios'
import { host } from '@/utils/service/url'
import store from '@/store/index'
export default {
  components: {
    uploadDialog
  },
  data () {
    return {
      permissionList: [],
      schoolList: [],
      majorList: [],
      resourceList: [],
      previewDialog: false,
      queryInfo: {
        currentPage: 1,
        pageSize: 10
      },
      total: 0,
      uploadData: {
        isOpen: false,
        id: ''
      },
      formData: {},
      searchInfo: {
        phone: ''
      },
      searchForm: {
        startTime: '',
        endTime: ''
      }
    }
  },
  directives: { permission },
  created () {
    this.getCompanyResource()
    this.permissionList = store.getters['login/getPermission']
  },
  methods: {
    /* 导出excel */
    exportExecl () {
      axios({
        url: host + 'company/exportExecl',
        method: 'post',
        responseType: 'blob',
        data: {
          ...this.searchForm
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: window.sessionStorage.getItem('token')
        }
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = `student${Math.floor(Math.random() * 10000)}.xlsx`
        document.body.appendChild(a)
        a.click()
      })
    },
    /* 获取公司资源 */
    getCompanyResource () {
      getCompanyResource(this.queryInfo).then(res => {
        this.resourceList = res.data.list
        this.total = res.data.total
      })
    },
    /* 删除公司资源 */
    deleteCompanyResouse (id) {
      deleteCompanyResouse(id).then(res => {
        this.getCompanyResource()
      })
    },
    /* 搜索 */
    searchHandle () {
      if (this.searchInfo.phone === '') {
        this.queryInfo.currentPage = 1
        this.getCompanyResource()
      } else {
        getInfoByPhone({ phone: this.searchInfo.phone }).then(res => {
          this.resourceList = res.data
        })
      }
    },
    /* 下载模板 */
    downloadTemplate () {
      axios({
        url: host + '/company/downloadTemplate',
        method: 'get',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: window.sessionStorage.getItem('token')
        }
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = `student${Math.floor(Math.random() * 10000)}.xlsx`
        document.body.appendChild(a)
        a.click()
      })
    },
    /* 分页选择 */
    handleSizeChange (size) {
      this.queryInfo.pageSize = size
      this.getCompanyResource()
    },
    handleCurrentChange (size) {
      this.queryInfo.currentPage = size
      this.getCompanyResource()
    },
    /* 关闭更新窗口 */
    closeDialog (data) {
      this.uploadData.isOpen = data.isOpen
      if (data.type === 'success') {
        this.getCompanyResource()
      }
    },
    // 删除
    deleteHandle (id) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteCompanyResouse(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-body {
  .search-form {
    padding: 20px 10px 0 0;
    background-color: #fff;
    .el-form {
      display: flex;
      justify-content: flex-end;
      .button-box {
        display: flex;
      }
    }
  }
}
.page-container {
  .el-card {
    ::v-deep .el-card__body {
      .el-row {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
  .pagination-body {
    .el-pagination {
      text-align: center;
      padding: 20px 0;
    }
  }
}
</style>
